import { UberConferenceServiceComponent } from './UberConferenceServiceComponent';
export const UberconferenceReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: UberConferenceServiceComponent
};